import {Section} from "./Section";
import {usePartners} from "../../api/partnerapi";
import {Button, Col} from "react-bootstrap";
import {minioBaseUrl} from "../../data/defaultConfig";

export function AsideRight(props) {
    const {partners} = usePartners();
    return <Section title={'Partners'}>
        {partners?.sort((p1,p2)=> p1.position-p2.position).map(p => <Partner key={p.id} partner={p}/>)}
    </Section>
}

function Partner(props) {
    const {partner} = props;
     return <Col className={'text-center mb-4'} xs={12}>
         <Button href={partner?.url} target={"_blank"} className={"bg-transparent  w-100 m-0 g-0 border-0 p-0"}>
             <img className={'mt-2'} width={'100vw'} src={`${minioBaseUrl}${partner.filepartners.url}`} alt={"image partner"}/>
         </Button>
     </Col>
}


